// import React, { useEffect, useState } from "react";
// import tw from "tailwind-styled-components";
// import {
//   BoxTitle,
//   BoxHead,
//   Underline,
// } from "../../Components/Styles/PageStyles";
// import AddNotice from "../../Components/Notice/AddNotice";
// import SideModal from "../../Components/SideModal";
// import { useMutation } from "react-query";
// import axios from "axios";
// import Config from "../../Config";
// import { useSelector } from "react-redux";
// import moment from "moment";
// import { FaCalendarAlt, FaBuilding, FaEye, FaTrash } from "react-icons/fa";
// import { MdPoll } from "react-icons/md";
// import { BiSolidLike } from "react-icons/bi";
// import ViewersModal from "../../Components/Notice/ViewersModal";
// import VotersModal from "../../Components/Notice/VotersModal";
// import PropertiesModal from "../../Components/Notice/PropertiesModal";
// import ReadMoreDescription from "../../Components/Notice/ReadMoreDescription";
// import NotFoundModel from "../../Components/NotFoundModel";
// import Loading from "../../Components/Loading";
// import { toast } from "react-toastify";
// import DeleteModal from "../../Components/Notice/DeleteModal";

// const Notice = () => {
//   const [isAddNotice, setIsAddNotice] = useState(false);
//   const [activeTab, setActiveTab] = useState("1");
//   const [apiData, setApiData] = useState([]);
//   const [displayCount, setDisplayCount] = useState(10);
//   const [viewersModalOpen, setViewersModalOpen] = useState(false);
//   const [viewersData, setViewersData] = useState([]);
//   const [votersModalOpen, setVotersModalOpen] = useState(false);
//   const [isDeleteNotice, setIsDeleteNotice] = useState(false);
//   const [votersData, setVotersData] = useState([]);
//   const [pollOptionsData, setPollOptionsData] = useState([]);
//   const [selectedNoticeData, setSelectedNoticeData] = useState(null);
//   const [propertiesModalOpen, setPropertiesModalOpen] = useState(false);
//   const [propertiesData, setPropertiesData] = useState([]);
//   const user = useSelector((state) => state.UserReducer.user);
//   const [selectedNoticeId, setSelectedNoticeId] = useState(null);

//   const fetchFunction = async () => {
//     const res = await axios.get(`${Config.apiUrl}/notice/list/client`, {
//       headers: {
//         authorization: `Bearer ${user.token}`,
//       },
//     });
//     return res.data;
//   };

//   const filterDataByTab = (data, tab) => {
//     if (!Array.isArray(data)) return;
//     const filtered =
//       tab === "1"
//         ? data.filter((n) => n.type === 1)
//         : data.filter((n) => n.type === 2);
//     setApiData(filtered);
//     setDisplayCount(10);
//   };

//   const { isLoading, mutate: getListMutate, data } = useMutation(fetchFunction, {
//     onSuccess: (res) => {
//       if (Array.isArray(res?.data)) {
//         filterDataByTab(res.data, activeTab);
//       } else {
//         setApiData([]);
//       }
//     },
//     onError: () => setApiData([]),
//   });

//   useEffect(() => {
//     getListMutate();
//   }, []);

//   useEffect(() => {
//     if (Array.isArray(data?.data)) {
//       filterDataByTab(data.data, activeTab);
//     }
//   }, [activeTab, data]);

//   const formatDate = (date) => {
//     if (!date) return "";
//     return moment(date).format("MMMM DD, YYYY · hh:mm A");
//   };

//   const loadMore = () => {
//     setDisplayCount((prevCount) => prevCount + 10);
//   };

//   const getDisplayedItems = () => {
//     return apiData.slice(0, displayCount);
//   };

//   const hasMoreItems = () => {
//     return displayCount < apiData.length;
//   };

//   const getVotersList = (notice) => {
//     if (!notice.pollResponses || !Array.isArray(notice.pollResponses))
//       return [];

//     const pollOptionsMap = {};
//     notice.pollOptions?.forEach((option) => {
//       pollOptionsMap[option.id] = option.description;
//     });

//     return notice.pollResponses.map((response) => ({
//       name: response.tenantName,
//       roomNum: response.roomNum,
//       selectedOption: response.description,
//       optionId: response.optionId,
//     }));
//   };

//   // Get unique viewers list
//   const getViewersList = (notice) => {
//     if (!notice.tenantViewed || !Array.isArray(notice.tenantViewed)) return [];

//     // If tenantViewed contains objects with name property
//     if (
//       notice.tenantViewed.length > 0 &&
//       typeof notice.tenantViewed[0] === "object"
//     ) {
//       return notice.tenantViewed.map((viewer) => viewer.name);
//     }
//     return notice.tenantViewed;
//   };

//   // Handlers for modals
//   const handleViewClick = (viewersList) => {
//     setViewersData(viewersList);
//     setViewersModalOpen(true);
//   };

//   const handleVoteClick = (votersList, pollOptions, notice) => {
//     setVotersData(votersList);
//     setPollOptionsData(pollOptions);
//     setSelectedNoticeData(notice);
//     setVotersModalOpen(true);
//   };

//   const handlePropertyClick = (propertyNames) => {
//     setPropertiesData(propertyNames);
//     setPropertiesModalOpen(true);
//   };

//   const displayedItems = getDisplayedItems();
//   const handleDeleteClick = (noticeId) => {
//     setSelectedNoticeId(noticeId);
//     setIsDeleteNotice(true);
//   };
//   //------- Delete Notice -------
//   const deleteNoticeFunction = async (values) => {
//     return await axios.post(`${Config.apiUrl}/notice/delete`, values, {
//       headers: {
//         "Content-Type": "application/json",
//         authorization: `Bearer ${user.token}`,
//       },
//     });
//   };

//   const deleteNoticeSuccess = (data) => {
//     setIsDeleteNotice(false);
//     setSelectedNoticeId(null);
//     getListMutate()
//     toast.success(data?.data?.msg || "Success");
//   };

//   const deleteNoticeError = (data) => {
//     setIsDeleteNotice(false);
//     toast.error(data?.response?.data?.msg || "An Error Occured");
//   };

//   const { isLoading: deleteNoticeLoading, mutate: deleteNoticeMutate } =
//     useMutation(deleteNoticeFunction, {
//       onSuccess: deleteNoticeSuccess,
//       onError: deleteNoticeError,
//     });


//   return (
//     <BoxContainer>
//       <SideModal isOpen={isAddNotice} onClose={() => setIsAddNotice(false)}>
//         <AddNotice setIsAddNotice={setIsAddNotice} isAddNotice={isAddNotice} />
//       </SideModal>

//       {viewersModalOpen && (
//         <ViewersModal
//           isOpen={viewersModalOpen}
//           onClose={() => setViewersModalOpen(false)}
//           viewers={viewersData}
//         />
//       )}

//       {votersModalOpen && (
//         <VotersModal
//           isOpen={votersModalOpen}
//           onClose={() => setVotersModalOpen(false)}
//           voters={votersData}
//           pollOptions={pollOptionsData}
//           selectedNotice={selectedNoticeData}
//         />
//       )}

//       {propertiesModalOpen && (
//         <PropertiesModal
//           isOpen={propertiesModalOpen}
//           onClose={() => setPropertiesModalOpen(false)}
//           properties={propertiesData}
//         />
//       )}

//       {isDeleteNotice && (
//         <DeleteModal
//           setIsDeleteNotice={setIsDeleteNotice}
//           isDeleteNotice={isDeleteNotice}
//           deleteNoticeLoading={deleteNoticeLoading}
//           deleteNoticeMutate={deleteNoticeMutate}
//           selectedData={{ id: selectedNoticeId }}
//         />
//       )}

//       <BoxHead>
//         <BoxTitle className="!mb-0 whitespace-nowrap">
//           Notice
//           <Underline />
//         </BoxTitle>
//         {/* <ApplyBtn onClick={() => setIsAddNotice(true)}>Add Notice</ApplyBtn> */}
//       </BoxHead>

//       <FloorTabs>
//         <FloorTab onClick={() => setActiveTab("1")} $active={activeTab === "1"}>
//           General
//         </FloorTab>
//         <FloorTab onClick={() => setActiveTab("2")} $active={activeTab === "2"}>
//           Polls
//         </FloorTab>
//       </FloorTabs>

//       {isLoading ? (
//         <Loading />
//       ) : apiData.length === 0 ? (
//         <NotFoundModel />
//       ) : (
//         <>
//           <MasonryGrid>
//             {displayedItems.map((notice) => {
//               const pollOptions = Array.isArray(notice.pollOptions)
//                 ? notice.pollOptions
//                 : [];
//               const responsesPerOption = Array.isArray(
//                 notice.pollResponsesPerOption,
//               )
//                 ? notice.pollResponsesPerOption
//                 : [];
//               const maxVotes = Math.max(
//                 ...(responsesPerOption.map((r) => r.total) || [0]),
//               );

//               const propertyNames = notice.propertyList?.map((p) => p.name) || [];
//               const viewersList = getViewersList(notice);
//               const votersList = getVotersList(notice);
//               const viewCount = notice.views || viewersList.length;
//               const voteCount = notice.totalPollResponses || 0;

//               return (
//                 <Card key={notice.id}>
//                   {/* HEADER */}
//                   <PostHeader>
//                     <Avatar>
//                       {notice.title?.charAt(0).toUpperCase() || "N"}
//                     </Avatar>

//                     <div className="flex-1">
//                       {" "}
//                       <PostTitle>{notice.title}</PostTitle>
//                       <PostTime>
//                         <FaCalendarAlt size={12} />
//                         {formatDate(notice.updatedAt)}
//                       </PostTime>
//                     </div>
//                     <DeleteButton onClick={() => handleDeleteClick(notice.id)}>
//                       <FaTrash size={16} />
//                     </DeleteButton>
//                   </PostHeader>

//                   {/* CONTENT */}
//                   {/* <ContentWrapper> */}
//                   {notice.img && <Image src={notice.img} alt="Notice" />}
//                   <div className="px-4">
//                     <ReadMoreDescription description={notice.description} />

//                     {/* POLL */}
//                     {notice.type === 2 && pollOptions.length > 0 && (
//                       <PollBox>
//                         <PollHeader>
//                           <MdPoll />
//                           Poll
//                         </PollHeader>

//                         {pollOptions.map((opt) => {
//                           const count =
//                             responsesPerOption.find((r) => r.optionId === opt.id)
//                               ?.total || 0;

//                           const percent = notice.totalPollResponses
//                             ? Math.round(
//                               (count / notice.totalPollResponses) * 100,
//                             )
//                             : 0;

//                           const isWinner = count === maxVotes && maxVotes > 0;

//                           return (
//                             <PollItem key={opt.id}>
//                               <PollText>
//                                 <span>{opt.description}</span>
//                                 <span>
//                                   {count} ({percent}%)
//                                 </span>
//                               </PollText>

//                               <ProgressBar>
//                                 <ProgressFill
//                                   $width={percent}
//                                   $winner={isWinner}
//                                 />
//                               </ProgressBar>
//                             </PollItem>
//                           );
//                         })}
//                       </PollBox>
//                     )}
//                   </div>
//                   <ActionBar>
//                     <ActionBtn onClick={() => handleViewClick(viewersList)}>
//                       <FaEye className="mr-2" /> {viewCount}
//                     </ActionBtn>

//                     {notice.type === 2 && (
//                       <ActionBtn
//                         onClick={() =>
//                           handleVoteClick(votersList, pollOptions, notice)
//                         }
//                       >
//                         <BiSolidLike className="mr-2" /> {voteCount}
//                       </ActionBtn>
//                     )}

//                     <ActionBtn
//                       onClick={() => handlePropertyClick(propertyNames)}
//                     >
//                       <FaBuilding className="mr-2" />
//                       {propertyNames.length > 1
//                         ? `${propertyNames[0]} +${propertyNames.length - 1}`
//                         : propertyNames[0] || "No Property"}
//                     </ActionBtn>
//                   </ActionBar>

//                   {/* </ContentWrapper> */}
//                 </Card>
//               );
//             })}
//           </MasonryGrid>
//           {/* Load More Button */}
//           {hasMoreItems() && (
//             <LoadMoreContainer>
//               <LoadMoreButton onClick={loadMore}>
//                 Load More ({apiData.length - displayCount} remaining)
//               </LoadMoreButton>
//             </LoadMoreContainer>
//           )}

//           {/* Optional: Show counter */}
//           <CounterInfo>
//             Showing {displayedItems.length} of {apiData.length} notices
//           </CounterInfo>
//         </>
//       )}
//     </BoxContainer>
//   );
// };

// export default Notice;

// /* ================= STYLES ================= */
// const ActionBar = tw.div`flex gap-4 border-t mt-2 text-sm text-gray-600`;
// const ActionBtn = tw.div`cursor-pointer px-3 py-3 rounded-md hover:bg-gray-100 flex items-center`;
// const BoxContainer = tw.div`Container py-6 relative`;
// const MasonryGrid = tw.div`
//   columns-1 md:columns-2
//   gap-4
// `;

// const Card = tw.div`
//   bg-white rounded-xl border border-gray-200
//   break-inside-avoid mb-4 w-full
// `;
// // const Card = tw.div`bg-white rounded-xl border border-gray-200 mt-4 mx-auto shadow-sm`;
// // const PostHeader = tw.div`flex items-center gap-3 px-4 pt-3`;
// const Avatar = tw.div`w-10 h-10 rounded-full bg-primary-color flex items-center justify-center text-white font-semibold`;
// const PostTitle = tw.div`text-sm font-semibold text-gray-900`;
// const PostTime = tw.div`text-xs text-gray-500 flex items-center gap-1`;
// // const ContentWrapper = tw.div`pb-3`;
// const Image = tw.img`w-full object-cover mt-2`;
// const PollBox = tw.div`my-3 bg-gray-50 p-3 rounded-lg`;
// const PollHeader = tw.div`flex items-center gap-2 text-sm font-medium mb-2`;
// const PollItem = tw.div`mb-2`;
// const PollText = tw.div`flex justify-between text-sm mb-1`;
// const ProgressBar = tw.div`h-2 bg-gray-200 rounded-full overflow-hidden`;
// const ProgressFill = tw.div`
//   h-full ${(p) => (p.$winner ? "bg-green-500" : "bg-gray-300")}
//   width: ${(p) => p.$width}%;
// `;
// const FloorTabs = tw.div`flex overflow-x-auto bg-white rounded-md my-4 border-b`;
// const FloorTab = tw.button`
//   ${(p) =>
//     p.$active
//       ? " text-primary-color border-b-2 border-b-primary-color bg-cyan-50 "
//       : " text-gray-700 "} 
//    px-5 py-3  cursor-pointer font-medium transition-all duration-200 whitespace-nowrap text-sm
// `;
// const ApplyBtn = tw.button`${(p) =>
//   p.$active
//     ? "bg-gray-100"
//     : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm`;
// const LoadMoreContainer = tw.div`flex justify-center mt-6 mb-4`;
// const LoadMoreButton = tw.button`px-6 py-2 bg-primary-color text-white rounded-md hover:bg-primary-color/90 transition-all duration-200 font-medium shadow-sm`;
// const CounterInfo = tw.div`text-center text-sm text-gray-500 mt-2`;
// const DeleteButton = tw.button`
//   text-gray-400 hover:text-red-500 transition-colors duration-200
//   focus:outline-none cursor-pointer
// `;
// const PostHeader = tw.div`
//   flex items-center gap-3 px-4 pt-3 justify-between
// `;

// // import React, { useEffect, useState } from "react";
// // import tw from "tailwind-styled-components";
// // import {
// //   BoxTitle,
// //   BoxHead,
// //   Underline,
// // } from "../../Components/Styles/PageStyles";
// // import AddNotice from "../../Components/Notice/AddNotice";
// // import SideModal from "../../Components/SideModal";
// // import { useMutation } from "react-query";
// // import axios from "axios";
// // import Config from "../../Config";
// // import { useSelector } from "react-redux";
// // import moment from "moment";
// // import { FaCalendarAlt, FaBuilding, FaEye, FaTrash } from "react-icons/fa";
// // import { MdPoll } from "react-icons/md";
// // import { BiSolidLike } from "react-icons/bi";
// // import ViewersModal from "../../Components/Notice/ViewersModal";
// // import VotersModal from "../../Components/Notice/VotersModal";
// // import PropertiesModal from "../../Components/Notice/PropertiesModal";
// // import ReadMoreDescription from "../../Components/Notice/ReadMoreDescription";
// // import NotFoundModel from "../../Components/NotFoundModel";
// // import Loading from "../../Components/Loading";
// // import { toast } from "react-toastify";
// // import DeleteModal from "../../Components/Notice/DeleteModal";

// // const Notice = () => {
// //   const [isAddNotice, setIsAddNotice] = useState(false);
// //   const [activeTab, setActiveTab] = useState("1");
// //   const [apiData, setApiData] = useState([]);
// //   const [displayCount, setDisplayCount] = useState(10);
// //   const [viewersModalOpen, setViewersModalOpen] = useState(false);
// //   const [viewersData, setViewersData] = useState([]);
// //   const [votersModalOpen, setVotersModalOpen] = useState(false);
// //   const [isDeleteNotice, setIsDeleteNotice] = useState(false);
// //   const [votersData, setVotersData] = useState([]);
// //   const [pollOptionsData, setPollOptionsData] = useState([]);
// //   const [selectedNoticeData, setSelectedNoticeData] = useState(null);
// //   const [propertiesModalOpen, setPropertiesModalOpen] = useState(false);
// //   const [propertiesData, setPropertiesData] = useState([]);
// //   const user = useSelector((state) => state.UserReducer.user);
// //   const [selectedNoticeId, setSelectedNoticeId] = useState(null);

// //   const fetchFunction = async () => {
// //     const res = await axios.get(`${Config.apiUrl}/notice/list/client`, {
// //       headers: {
// //         authorization: `Bearer ${user.token}`,
// //       },
// //     });
// //     return res.data;
// //   };

// //   const filterDataByTab = (data, tab) => {
// //     if (!Array.isArray(data)) return;
// //     const filtered =
// //       tab === "1"
// //         ? data.filter((n) => n.type === 1)
// //         : data.filter((n) => n.type === 2);
// //     setApiData(filtered);
// //     setDisplayCount(10);
// //   };

// //   const { isLoading, mutate: getListMutate, data } = useMutation(fetchFunction, {
// //     onSuccess: (res) => {
// //       if (Array.isArray(res?.data)) {
// //         filterDataByTab(res.data, activeTab);
// //       } else {
// //         setApiData([]);
// //       }
// //     },
// //     onError: () => setApiData([]),
// //   });

// //   useEffect(() => {
// //     getListMutate();
// //   }, []);

// //   useEffect(() => {
// //     if (Array.isArray(data?.data)) {
// //       filterDataByTab(data.data, activeTab);
// //     }
// //   }, [activeTab, data]);

// //   const formatDate = (date) => {
// //     if (!date) return "";
// //     return moment(date).format("MMMM DD, YYYY · hh:mm A");
// //   };

// //   const loadMore = () => {
// //     setDisplayCount((prevCount) => prevCount + 10);
// //   };

// //   const getDisplayedItems = () => {
// //     return apiData.slice(0, displayCount);
// //   };

// //   const hasMoreItems = () => {
// //     return displayCount < apiData.length;
// //   };

// //   const getVotersList = (notice) => {
// //     if (!notice.pollResponses || !Array.isArray(notice.pollResponses))
// //       return [];

// //     const pollOptionsMap = {};
// //     notice.pollOptions?.forEach((option) => {
// //       pollOptionsMap[option.id] = option.description;
// //     });

// //     return notice.pollResponses.map((response) => ({
// //       name: response.tenantName,
// //       roomNum: response.roomNum,
// //       selectedOption: response.description,
// //       optionId: response.optionId,
// //     }));
// //   };

// //   const getViewersList = (notice) => {
// //     if (!notice.tenantViewed || !Array.isArray(notice.tenantViewed)) return [];

// //     if (
// //       notice.tenantViewed.length > 0 &&
// //       typeof notice.tenantViewed[0] === "object"
// //     ) {
// //       return notice.tenantViewed.map((viewer) => viewer.name);
// //     }
// //     return notice.tenantViewed;
// //   };

// //   const handleViewClick = (viewersList) => {
// //     setViewersData(viewersList);
// //     setViewersModalOpen(true);
// //   };

// //   const handleVoteClick = (votersList, pollOptions, notice) => {
// //     setVotersData(votersList);
// //     setPollOptionsData(pollOptions);
// //     setSelectedNoticeData(notice);
// //     setVotersModalOpen(true);
// //   };

// //   const handlePropertyClick = (propertyNames) => {
// //     setPropertiesData(propertyNames);
// //     setPropertiesModalOpen(true);
// //   };

// //   const displayedItems = getDisplayedItems();

// //   const handleDeleteClick = (noticeId) => {
// //     setSelectedNoticeId(noticeId);
// //     setIsDeleteNotice(true);
// //   };

// //   const deleteNoticeFunction = async (values) => {
// //     return await axios.post(`${Config.apiUrl}/notice/delete`, values, {
// //       headers: {
// //         "Content-Type": "application/json",
// //         authorization: `Bearer ${user.token}`,
// //       },
// //     });
// //   };

// //   const deleteNoticeSuccess = (data) => {
// //     setIsDeleteNotice(false);
// //     setSelectedNoticeId(null);
// //     getListMutate()
// //     toast.success(data?.data?.msg || "Success");
// //   };

// //   const deleteNoticeError = (data) => {
// //     setIsDeleteNotice(false);
// //     toast.error(data?.response?.data?.msg || "An Error Occured");
// //   };

// //   const { isLoading: deleteNoticeLoading, mutate: deleteNoticeMutate } =
// //     useMutation(deleteNoticeFunction, {
// //       onSuccess: deleteNoticeSuccess,
// //       onError: deleteNoticeError,
// //     });

// //   return (
// //     <BoxContainer>
// //       <SideModal isOpen={isAddNotice} onClose={() => setIsAddNotice(false)}>
// //         <AddNotice setIsAddNotice={setIsAddNotice} isAddNotice={isAddNotice} />
// //       </SideModal>

// //       {viewersModalOpen && (
// //         <ViewersModal
// //           isOpen={viewersModalOpen}
// //           onClose={() => setViewersModalOpen(false)}
// //           viewers={viewersData}
// //         />
// //       )}

// //       {votersModalOpen && (
// //         <VotersModal
// //           isOpen={votersModalOpen}
// //           onClose={() => setVotersModalOpen(false)}
// //           voters={votersData}
// //           pollOptions={pollOptionsData}
// //           selectedNotice={selectedNoticeData}
// //         />
// //       )}

// //       {propertiesModalOpen && (
// //         <PropertiesModal
// //           isOpen={propertiesModalOpen}
// //           onClose={() => setPropertiesModalOpen(false)}
// //           properties={propertiesData}
// //         />
// //       )}

// //       {isDeleteNotice && (
// //         <DeleteModal
// //           setIsDeleteNotice={setIsDeleteNotice}
// //           isDeleteNotice={isDeleteNotice}
// //           deleteNoticeLoading={deleteNoticeLoading}
// //           deleteNoticeMutate={deleteNoticeMutate}
// //           selectedData={{ id: selectedNoticeId }}
// //         />
// //       )}

// //       <BoxHead>
// //         <BoxTitle className="!mb-0 whitespace-nowrap">
// //           Notice
// //           <Underline />
// //         </BoxTitle>
// //       </BoxHead>

// //       <FloorTabs>
// //         <FloorTab onClick={() => setActiveTab("1")} $active={activeTab === "1"}>
// //           General
// //         </FloorTab>
// //         <FloorTab onClick={() => setActiveTab("2")} $active={activeTab === "2"}>
// //           Polls
// //         </FloorTab>
// //       </FloorTabs>

// //       {isLoading ? (
// //         <Loading />
// //       ) : apiData.length === 0 ? (
// //         <NotFoundModel />
// //       ) : (
// //         <>
// //           <MasonryGrid>
// //             {displayedItems.map((notice) => {
// //               const pollOptions = Array.isArray(notice.pollOptions)
// //                 ? notice.pollOptions
// //                 : [];
// //               const responsesPerOption = Array.isArray(
// //                 notice.pollResponsesPerOption,
// //               )
// //                 ? notice.pollResponsesPerOption
// //                 : [];
// //               const maxVotes = Math.max(
// //                 ...(responsesPerOption.map((r) => r.total) || [0]),
// //               );

// //               const propertyNames = notice.propertyList?.map((p) => p.name) || [];
// //               const viewersList = getViewersList(notice);
// //               const votersList = getVotersList(notice);
// //               const viewCount = notice.views || viewersList.length;
// //               const voteCount = notice.totalPollResponses || 0;

// //               // Determine card size based on content
// //               const hasImage = !!notice.img;
// //               const hasPoll = notice.type === 2 && pollOptions.length > 0;
// //               const isLongContent = notice.description?.length > 200;
// //               const cardSize = hasImage ? 'large' : hasPoll ? 'medium' : isLongContent ? 'medium' : 'small';

// //               return (
// //                 <MasonryItem key={notice.id} $size={cardSize}>
// //                   <Card>
// //                     <CardGlow />

// //                     <PostHeader>
// //                       <Avatar $type={notice.type}>
// //                         {notice.title?.charAt(0).toUpperCase() || "N"}
// //                       </Avatar>

// //                       <div className="flex-1 min-w-0">
// //                         <PostTitle>{notice.title}</PostTitle>
// //                         <PostTime>
// //                           <FaCalendarAlt size={12} />
// //                           {formatDate(notice.updatedAt)}
// //                         </PostTime>
// //                       </div>
// //                       <DeleteButton onClick={() => handleDeleteClick(notice.id)}>
// //                         <FaTrash size={16} />
// //                       </DeleteButton>
// //                     </PostHeader>

// //                     <ContentWrapper>
// //                       <ReadMoreDescription description={notice.description} />

// //                       {notice.img && (
// //                         <ImageWrapper>
// //                           <Image src={notice.img} alt="Notice" />
// //                         </ImageWrapper>
// //                       )}

// //                       {notice.type === 2 && pollOptions.length > 0 && (
// //                         <PollBox>
// //                           <PollHeader>
// //                             <MdPoll className="text-primary-color" />
// //                             <span>Poll Results</span>
// //                           </PollHeader>

// //                           <PollGrid>
// //                             {pollOptions.map((opt, index) => {
// //                               const count =
// //                                 responsesPerOption.find((r) => r.optionId === opt.id)
// //                                   ?.total || 0;

// //                               const percent = notice.totalPollResponses
// //                                 ? Math.round(
// //                                   (count / notice.totalPollResponses) * 100,
// //                                 )
// //                                 : 0;

// //                               const isWinner = count === maxVotes && maxVotes > 0;

// //                               return (
// //                                 <PollItem key={opt.id} $winner={isWinner}>
// //                                   <PollLabel>
// //                                     <PollDot $color={getPollColor(index)} />
// //                                     <span className="flex-1">{opt.description}</span>
// //                                     <PollCount>{count}</PollCount>
// //                                   </PollLabel>

// //                                   <ProgressBar>
// //                                     <ProgressFill
// //                                       $width={percent}
// //                                       $winner={isWinner}
// //                                       $color={getPollColor(index)}
// //                                     />
// //                                   </ProgressBar>
// //                                   <PollPercent>{percent}%</PollPercent>
// //                                 </PollItem>
// //                               );
// //                             })}
// //                           </PollGrid>
// //                         </PollBox>
// //                       )}

// //                       <ActionBar>
// //                         <ActionBtn onClick={() => handleViewClick(viewersList)}>
// //                           <FaEye className="mr-1.5" />
// //                           <span>{viewCount}</span>
// //                         </ActionBtn>

// //                         {notice.type === 2 && (
// //                           <ActionBtn
// //                             onClick={() =>
// //                               handleVoteClick(votersList, pollOptions, notice)
// //                             }
// //                           >
// //                             <BiSolidLike className="mr-1.5" />
// //                             <span>{voteCount}</span>
// //                           </ActionBtn>
// //                         )}

// //                         <ActionBtn
// //                           onClick={() => handlePropertyClick(propertyNames)}
// //                           className="ml-auto"
// //                         >
// //                           <FaBuilding className="mr-1.5" />
// //                           <span>
// //                             {propertyNames.length > 1
// //                               ? `${propertyNames[0]} +${propertyNames.length - 1}`
// //                               : propertyNames[0] || "No Property"}
// //                           </span>
// //                         </ActionBtn>
// //                       </ActionBar>
// //                     </ContentWrapper>
// //                   </Card>
// //                 </MasonryItem>
// //               );
// //             })}
// //           </MasonryGrid>

// //           {hasMoreItems() && (
// //             <LoadMoreContainer>
// //               <LoadMoreButton onClick={loadMore}>
// //                 Load More
// //                 <LoadMoreBadge>
// //                   {apiData.length - displayCount}
// //                 </LoadMoreBadge>
// //               </LoadMoreButton>
// //             </LoadMoreContainer>
// //           )}

// //           <CounterInfo>
// //             Showing {displayedItems.length} of {apiData.length} notices
// //           </CounterInfo>
// //         </>
// //       )}
// //     </BoxContainer>
// //   );
// // };

// // export default Notice;

// // // Helper function for poll colors
// // const getPollColor = (index) => {
// //   const colors = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899'];
// //   return colors[index % colors.length];
// // };

// // /* ================= STYLES ================= */
// // const BoxContainer = tw.div`Container py-6 relative max-w-7xl mx-auto px-4`;

// // // CSS Masonry Grid using columns
// // const MasonryGrid = tw.div`
// //   columns-1 sm:columns-2 lg:columns-3 gap-6 mt-6
// //   [column-fill:_balance]
// // `;

// // const MasonryItem = tw.div`
// //   break-inside-avoid mb-6
// //   ${(p) => p.$size === 'large' ? 'sm:column-span-1' : ''}
// // `;

// // const Card = tw.div`
// //   relative bg-white rounded-2xl border border-gray-100 
// //   shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)]
// //   hover:shadow-[0_8px_30px_-6px_rgba(0,0,0,0.12),0_20px_40px_-4px_rgba(0,0,0,0.08)]
// //   transition-all duration-500 ease-out
// //   hover:-translate-y-1
// //   overflow-hidden
// //   group
// // `;

// // const CardGlow = tw.div`
// //   absolute inset-0 rounded-2xl opacity-0 transition-opacity duration-500
// //   bg-gradient-to-br from-primary-color/5 via-transparent to-cyan-400/5
// //   group-hover:opacity-100 pointer-events-none
// // `;

// // const PostHeader = tw.div`
// //   flex items-center gap-3 p-5 pb-2
// // `;

// // const Avatar = tw.div`
// //   w-12 h-12 rounded-2xl flex items-center justify-center text-white font-bold text-lg
// //   shadow-lg flex-shrink-0
// //   ${(p) => p.$type === 2
// //     ? 'bg-gradient-to-br from-amber-400 to-orange-500'
// //     : 'bg-gradient-to-br from-primary-color to-cyan-500'}
// // `;

// // const PostTitle = tw.div`
// //   font-semibold text-gray-800 text-base leading-tight
// // `;

// // const PostTime = tw.div`
// //   text-xs text-gray-400 flex items-center gap-1.5 mt-1
// // `;

// // const ContentWrapper = tw.div`px-5 pb-5`;

// // const ImageWrapper = tw.div`
// //   mt-3 rounded-xl overflow-hidden bg-gray-50
// // `;

// // const Image = tw.img`
// //   w-full h-auto object-cover hover:scale-105 transition-transform duration-500
// // `;

// // const PollBox = tw.div`
// //   mt-4 bg-gradient-to-br from-gray-50 to-gray-100/50 rounded-xl p-4 
// //   border border-gray-100
// // `;

// // const PollHeader = tw.div`
// //   flex items-center gap-2 text-sm font-semibold mb-3 text-gray-700
// // `;

// // const PollGrid = tw.div`space-y-3`;

// // const PollItem = tw.div`
// //   ${(p) => p.$winner ? 'bg-green-50/50 -mx-2 px-2 py-1.5 rounded-lg' : ''}
// // `;

// // const PollLabel = tw.div`
// //   flex items-center gap-2 text-sm mb-1.5
// // `;

// // const PollDot = tw.span`
// //   w-2.5 h-2.5 rounded-full flex-shrink-0
// //   ${(p) => `background-color: ${p.$color}`}
// // `;

// // const PollCount = tw.span`
// //   text-xs font-semibold text-gray-600 bg-gray-100 px-2 py-0.5 rounded-full
// // `;

// // const ProgressBar = tw.div`
// //   h-2 bg-gray-200/80 rounded-full overflow-hidden
// // `;

// // const ProgressFill = tw.div`
// //   h-full rounded-full transition-all duration-1000 ease-out
// //   ${(p) => p.$winner
// //     ? 'bg-gradient-to-r from-green-400 to-emerald-500'
// //     : `background: linear-gradient(90deg, ${p.$color}CC, ${p.$color})`}
// //   width: ${(p) => p.$width}%;
// // `;

// // const PollPercent = tw.div`
// //   text-xs text-gray-400 mt-0.5 text-right
// // `;

// // const ActionBar = tw.div`
// //   flex items-center gap-1 border-t border-gray-100 mt-4 pt-3 flex-wrap
// // `;

// // const ActionBtn = tw.button`
// //   flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium
// //   text-gray-500 hover:text-gray-700 hover:bg-gray-50
// //   transition-all duration-200 cursor-pointer
// // `;

// // const FloorTabs = tw.div`
// //   flex overflow-x-auto bg-white/60 backdrop-blur-sm rounded-xl my-4 p-1 gap-1
// //   border border-gray-100 shadow-sm
// // `;

// // const FloorTab = tw.button`
// //   ${(p) =>
// //     p.$active
// //       ? "bg-white text-primary-color shadow-md shadow-primary-color/10"
// //       : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"}
// //   px-5 py-2.5 rounded-lg cursor-pointer font-medium transition-all duration-300 
// //   whitespace-nowrap text-sm flex-1 md:flex-none
// // `;

// // const LoadMoreContainer = tw.div`flex justify-center mt-8 mb-4`;
// // const LoadMoreButton = tw.button`
// //   flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-primary-color to-cyan-500 
// //   text-white rounded-xl hover:shadow-lg hover:shadow-primary-color/25 
// //   transition-all duration-300 font-medium text-sm
// //   hover:-translate-y-0.5
// // `;
// // const LoadMoreBadge = tw.span`
// //   bg-white/20 px-2 py-0.5 rounded-full text-xs
// // `;

// // const CounterInfo = tw.div`
// //   text-center text-sm text-gray-400 mt-3 font-medium
// // `;

// // const DeleteButton = tw.button`
// //   text-gray-300 hover:text-red-400 transition-all duration-200
// //   hover:bg-red-50 p-2 rounded-xl cursor-pointer flex-shrink-0
// // `;


import React, { useState } from "react";
import tw from "tailwind-styled-components";
import {

  BoxTitle,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import AddNotice from "../../Components/Notice/AddNotice";
import ComingSoon from "../../Components/ComingSoon";

const noticeData = [
  {
    id: 1,
    title: "Water Supply Interruption",
    description:
      "Please note that there will be a temporary water supply interruption on 10th Feb from 9 AM to 1 PM due to maintenance work.",
    postingTime: "Posted on: 05 Feb 2025, 10:00 AM",
    propertyName: "Sunrise Apartments",
    media: "https://via.placeholder.com/400x200",
  },
  {
    id: 2,
    title: "Electricity Maintenance",
    description:
      "There will be scheduled electricity maintenance on 12th Feb from 2 PM to 4 PM. Kindly make necessary arrangements.",
    postingTime: "Posted on: 06 Feb 2025, 11:00 AM",
    propertyName: "Sunrise Apartments",
  },
];

const Notice = () => {
  const [isAddNotice, setIsAddNotice] = useState(false);
  const handleAddNoticeClose = () => {
    setIsAddNotice(false);
  };
  return (
    <BoxContainer>
      {/* <div
        className={`${isAddNotice ? "flex" : "hidden"
          } h-screen w-screen bg-black/30 backdrop-blur-sm fixed inset-0 transition-all duration-400 ease-in-out`}
      />
      <div
        className={`${isAddNotice ? "translate-x-0" : "translate-x-full"
          } fixed h-screen right-0 top-0 transition-all duration-300 ease-in-out bg-white flex items-start rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
      >
        <AddNotice
          setIsAddNotice={setIsAddNotice}
          isAddNotice={isAddNotice}
          handleClose={handleAddNoticeClose}
        />
      </div>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Notice
          <Underline />
        </BoxTitle>
        <ApplyBtn
          type="button"
          onClick={() => {
            setIsAddNotice(true);
          }}
        >
          {"Add Notice"}
        </ApplyBtn>
      </BoxHead>
      {noticeData.map((notice) => (
        <Card key={notice.id}>
          <Title>{notice.title}</Title>
          <ContentWrapper>
            <div
              className={
                notice.media ? "md:col-span-2 md:mr-4" : "md:col-span-3"
              }
            >
              <Description>{notice.description}</Description>
              <MetaInfo>{notice.postingTime}</MetaInfo>
              <MetaInfo>Property: {notice.propertyName}</MetaInfo>
            </div>
            {notice.media && <Image src={notice.media} alt="Notice Media" />}
          </ContentWrapper>
        </Card>
      ))} */}
      {/* <Content>
        <Title>Coming Soon...</Title>
        <Subtitle>We're working hard to bring something amazing!</Subtitle>
      </Content> */}
      <ComingSoon />
    </BoxContainer>
  );
};
const BoxContainer = tw.div`Container py-6 relative`;
const Content = tw.div`text-center p-8 sm:p-12 max-w-xl w-full absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2`;
const Subtitle = tw.p`text-base sm:text-lg text-gray-600`;
const Card = tw.div`bg-white shadow-lg rounded-2xl p-4 w-full mx-auto mt-6 border border-gray-200`;
const Title = tw.h2`text-xl font-bold text-gray-800 mb-2`;
const Description = tw.p`text-gray-600 mb-4`;
const MetaInfo = tw.div`text-sm text-gray-500 mb-2`;
const ContentWrapper = tw.div`grid md:grid-cols-3 grid-cols-1 gap-4`;
const Image = tw.img`w-full object-cover rounded-lg`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6 cursor-pointer bg-primary-color hover:bg-hover-color py-2.5 text-sm`;

export default Notice;